module.exports = __webpack_public_path__ + "static/media/alarm.6330b150.svg";